// extracted by mini-css-extract-plugin
export default {"cardToggle":"themeSwitcher_cardToggle__r1YsN","themeToggle":"themeSwitcher_themeToggle__0yuI8"};